import axios from 'axios';
import { useQuery } from 'react-query';
import Config from '../../global/env';
import { AuditLogReportRequest, EnrollmentReportItem } from '../../model/auditlogreports';

const fetchUserEnrollments = async (request: AuditLogReportRequest): Promise<EnrollmentReportItem[]> => {
  const url = Config.auditReportsBaseURL + 'enrollment/users';
  const { data } = await axios.post(url, request);
  //@ts-ignore
  const rows: EnrollmentReportItem[] = data.map(item => new EnrollmentReportItem(item));
  return rows;
}

const useUserEnrollments = (request: AuditLogReportRequest) => {
  return useQuery<EnrollmentReportItem[], Error>(['UserEnrollments', request], () => fetchUserEnrollments(request));
}

export default useUserEnrollments;